/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Visibility } from "@mui/icons-material";
import {
  Button,
  Card,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Select,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { getScreenRight } from "utils/generic";
import ShowProfile from "components/ShowProfileModal/ShowProfileModal";
import { blank } from "utils/generic";
import { getParameterListName } from "utils/api";
import { generateDataList } from "utils/generic";
import { validateField } from "utils/generic";
import { updateVehicleDocumentByID } from "utils/api";
import { saveVehicleDocument } from "utils/api";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { getVehicleDocumentById } from "utils/api";
import { useDispatch } from "react-redux";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
let fetchedData;
function AddVehicleDocument() {
  const { id } = useParams();
  const { vehicleID } = useParams();
  const [screenName, setScreenName] = useState("Add New Document");
  const [document, setDocument] = useState("");
  const [documentFileNameErr, setDocumentFileNameErr] = useState(false);
  const [documentTypeErr, setDocumentTypeErr] = useState(false);
  const [documentNameErr, setDocumentNameErr] = useState(false);
  const [file, setFile] = useState();
  const [actualFile, setActualFile] = useState();
  const [fileName, setFileName] = useState("");
  const [imgSupportingText, setImgSupportingText] = useState("");
  const [showProfileModalFlag, setShowProfileModalFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [hideEyeBtn, setHideEyeBtn] = useState(false);
  const [controller,] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [values, setValues] = React.useState({
    documentName: "",
    documentType: "",
    documentFileName: "",
  });


  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  let mandateFlag = false;
  useEffect(() => {
    (async () => {
      await getRight()
      await fetchVehicleDocumentType();
      if (id !== undefined) {
        setScreenName("Edit Document")
        const urlParams = new URLSearchParams(window.location.search);
        const paramValue1 = urlParams.get('ve');
        values.vehicleID = paramValue1
        values._id = id;
        await getVehicleDocumentById(values, (data) => {
          if (data.Result_Output[0]._id !== undefined) {
            fetchedData = data.Result_Output[0];
            setFileName(fetchedData.documentFileName)
            setValues(fetchedData);
            values.documentFileName = fetchedData.documentFileName;
          }
          if (values.documentFileName !== undefined && values.documentFileName !== "") {
            setHideEyeBtn(true)
            setFile(appConstants.baseURL + "vehicle/viewFile?fileName=" + values.documentFileName);
          }
        }, dispatch)

      } else {
        values.vehicleID = vehicleID
      }
    })()
  }, [dispatch]);


  async function getRight() {
    let right = await getScreenRight("Vehicles")
    if (right === "Full Access")
      setDisableColor(false)
    else setDisableColor(true)
  }

  const clearErrorStates = () => {
    setDocumentNameErr(false)
    setDocumentTypeErr(false)
    setDocumentFileNameErr(false)
  };
  const addVehicleDocument = () => {
    sessionStorage.setItem("PARA_TABLE", "documents");
    mandateFlag = false;
    clearErrorStates()
    mandateFlag = validateField(values.documentName, setDocumentNameErr) || mandateFlag;
    mandateFlag = validateField(values.documentType, setDocumentTypeErr) || mandateFlag;
    mandateFlag = validateField(fileName, setDocumentFileNameErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const formData = new FormData();
    formData.append('file', actualFile);
    formData.append("fileName", fileName);
    formData.append("documentName", values.documentName);
    formData.append("documentType", values.documentType);
    formData.append("documentFileName", values.documentFileName);
    formData.append("vehicleID", vehicleID);
    formData.append("id", id);
    const apiFunction = vehicleID !== undefined ? saveVehicleDocument : updateVehicleDocumentByID
    apiFunction(formData, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, `/vehicles/editVehicle/${values.vehicleID}`);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  const saveFile = (e) => {
    setFile(URL.createObjectURL(e.target.files[0]));
    setActualFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
    setImgSupportingText("none");

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setShowProfileModalFlag(false);
        setHideEyeBtn(true);
      };
      reader.readAsDataURL(file);
    } else {
      setHideEyeBtn(false);
    }
  };

  const viewProfilePic = () => {
    setShowProfileModalFlag(!showProfileModalFlag)
  }

  const handleCancelProfilePic = name => event => {
    setShowProfileModalFlag(false)
  };

  let fetchVehicleDocumentType = async () => {
    getParameterListName(async (data) => {
      if ((data.Result_Output).length > 0) {
        for (let parameter of data.Result_Output) {
          if (parameter.parameterCode === "DT") {
            parameter.parameterList.sort((a, b) => a.parameterListSequence - b.parameterListSequence);
            setDocument(await generateDataList(parameter.parameterList, "parameterListName", "parameterListName"))
          }

        }
      }
    })
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={6} spacing={6}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <MDBox pt={4} pb={3} px={3}>
                <Grid container rowGap={3}>
                  <Grid item xs={12} lg={12}>
                    <MDBox component="form" role="form">

                      <TextField
                        type="text"
                        label="Document Name"
                        variant="outlined"
                        fullWidth
                        autoFocus={true}
                        inputProps={{
                          pattern: "^[a-zA-Z0-9 ]+$",
                          maxLength: 50
                        }}
                        onChange={handleChange("documentName")}
                        value={values.documentName}
                      />
                      {documentNameErr ? <span style={errMsg}>Document Name can't be blank</span> : ""}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Document Type</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        name="userType"
                        id="demo-simple-select"
                        style={{ minHeight: "44.11px" }}
                        label="Document Type"
                        onChange={handleChange("documentType")}
                        value={values.documentType}
                      >
                        {document}
                      </Select>
                    </FormControl>
                    {documentTypeErr ? <span style={errMsg}>Document Type can't be blank</span> : ""}
                  </Grid>
                  <Grid item xs={12} lg={11}>
                    <label htmlFor="fileInput">
                      <TextField
                        type="text"
                        label="Upload Document"
                        InputLabelProps={fileName ? { shrink: true } : { shrink: false }}
                        variant="outlined"
                        fullWidth
                        value={fileName}

                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <label htmlFor="fileInput">
                                <Button
                                  variant="contained"
                                  color="dark"
                                  component="span"
                                  size="small"
                                  allign="right"
                                  style={darkMode ? { color: "black" } : { color: "black" }}
                                >
                                  Choose File
                                </Button>
                              </label>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <input
                        type="file"
                        accept="image/*"
                        id="fileInput"
                        style={{ display: 'none' }}
                        onChange={saveFile}
                      />
                    </label>
                    {documentFileNameErr ? <span style={errMsg}>Upload Document can't be blank</span> : ""}
                  </Grid>
                  <Grid item xs={1}>
                    {hideEyeBtn ?
                      <IconButton style={{ marginLeft: '6px', marginTop: '-3px' }}>
                        <Visibility fontSize="large" color="info" onClick={viewProfilePic} />
                      </IconButton>
                      :
                      <IconButton style={{ marginLeft: '6px', marginTop: '-3px' }}>
                        <Visibility fontSize="large" color="grey" />
                      </IconButton>
                    }
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>
            <Link to={`/vehicles/editVehicle/${values.vehicleID}`}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                onClick={() => { sessionStorage.setItem("PARA_TABLE", "documents"); }}
              >
                Cancel
              </MDButton>
            </Link>

          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>
            <MDButton rel="noreferrer" variant="gradient" className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"} onClick={disableColor ? blank : addVehicleDocument} fullWidth>
              {id === undefined ? 'Save' : 'Update'}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
      <ShowProfile
        open={showProfileModalFlag}
        fileName={file}
        closeModalClick={handleCancelProfilePic('closeModalClick')}

      />
    </DashboardLayout>
  );
}

export default AddVehicleDocument;
